import { Fragment } from "react";

import { settings } from "../../Services/apiSetting";

const renderParagraph = (value) => {
  const lines = String(value ?? "").split("\n");

  return (
    <p>
      {lines.map((line, index) => (
        <Fragment key={index}>
          {index > 0 && <br />}
          {line}
        </Fragment>
      ))}
    </p>
  );
};

export const getStoreLocationsItems = async () => {
  const response = await fetch(settings.storeLocationsJsonUrl);

  if (!response.ok) {
    throw new Error(`Failed to load store locations JSON: ${response.status}`);
  }

  const storeLocations = await response.json();

  if (!Array.isArray(storeLocations)) {
    throw new Error("Invalid store locations JSON format.");
  }

  return storeLocations.map((store) => ({
    ...store,
    address: renderParagraph(store.address),
    phoneNumber: renderParagraph(store.phoneNumber),
    hours: renderParagraph(store.hours),
  }));
};
